import firebase from 'firebase';
import { useState } from 'react';
import { useFirebaseApp } from 'reactfire';
import { v4 as uuidv4 } from 'uuid';
import { useUploadFacturaMutation } from 'src/generated/graphql';

export const useUploadFacturas = () => {
  const [submitFactura] = useUploadFacturaMutation({
    refetchQueries: ['fetchIndividualAppointment']
  });
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState<firebase.storage.FirebaseStorageError>();
  const [urls, setUrls] = useState<string[]>([]);
  const [uploading, setUploading] = useState(false);

  const projectStorage = useFirebaseApp().storage();

  const uploadFiles = (files: File[], appointment_id: string) => {
    const uuid = uuidv4();
    setUploading(true);
    for (let file of files) {
      // storage ref
      const storageRef = projectStorage
        .ref()
        .child(`facturas/${uuid}/${file.name}`);

      storageRef.put(file).on(
        'state_changed',
        snap => {
          // track the upload progress
          let percentage = Math.round(
            (snap.bytesTransferred / snap.totalBytes) * 100
          );
          setProgress(percentage);
        },
        err => {
          setError(err);
        },
        async () => {
          // get the public download img url
          const downloadUrl: string = await storageRef.getDownloadURL();
          submitFactura({
            variables: {
              factura: {
                appointment_id: appointment_id,
                file_url: downloadUrl,
                storage_location: storageRef.fullPath
              }
            }
          });
          // save the url to local state
          let tempUrlArray = urls;
          tempUrlArray.push(downloadUrl);
          setUrls(tempUrlArray);
        }
      );
    }
    setUploading(false);
  };

  return { progress, urls, error, uploadFiles, uploading };
};
